import React from "react";
import classnames from 'classnames'
import ReactModal from 'react-modal';
import { Translate, withLocalize } from "react-localize-redux";
import ModalInner from "../../layoutItems/modalInner";

class SharePortfolioConfirmationPopup extends React.Component {
    render()
    {
        return (
            <ReactModal
                isOpen={this.props.open} ariaHideApp={false}
                style={{ content: { padding: localStorage.locales_popup_header_style === 'standard' ? '0.75em' : 0 }}}
            >
                <ModalInner close={() => this.props.close()} title={this.props.translate("Monitoring.Share.SaveChanges")}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <span>
                            <button className={classnames('bb-button is-primary gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                                onClick={() => this.props.ok()}
                            >
                                <Translate id="Common.Yes" />
                            </button>
                            <button className={classnames('bb-button is-primary gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                                onClick={() => this.props.cancel()}
                            >
                                <Translate id="Common.No" />
                            </button>
                        </span>
                        <button className={classnames('bb-button is-primary gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                            onClick={() => this.props.close()}
                        >
                            <Translate id="Common.Button.Cancel" />
                        </button>
                    </div>
                </ModalInner>
            </ReactModal>
        )
    }
}

export default withLocalize(SharePortfolioConfirmationPopup);